<!-- Reconciliation Modal -->
<ps-ui-modal
  class="reconcileSummaryModal"
  *ngIf="reconSummaryData"
  [showButtonClose]="true"
>
  <ps-ui-modal-title class="center-align" [ngSwitch]="true">
    <ng-template [ngSwitchCase]="isConfirmationTitle">
      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <div *ngIf="!isLiveRecon" class="boxRejectAccept acceptColor">
          ACCEPT
        </div>
        <div *ngIf="isLiveRecon" class="boxRejectAccept rejectColor">
          REJECT
        </div>
        Transaction Processing Confirmation
      </div>
    </ng-template>
    <ng-template ngSwitchDefault> Reconciliation</ng-template>
    <ng-template [ngSwitchCase]="!reconSummaryData.status"
      >Transaction Summary</ng-template
    >
  </ps-ui-modal-title>
  <ps-ui-modal-body>
    <div *ngIf="!reconSummaryData.status">
      <ng-container class="reconcileSummaryModal">
        <div class="summary-div">
          <div class="row text-center">
            <div
              [ngClass]="reconSummaryData?.user ? 'col-6' : 'col-12'"
              *ngIf="reconSummaryData?.fileName"
            >
              <p class="fw-bold">FILE NAME</p>
              <p class="text-dark">
                {{
                  reconSummaryData.fileName.substring(
                    reconSummaryData.fileName!.indexOf('_') + 1
                  )
                }}
              </p>
            </div>
            <div class="col-6" *ngIf="reconSummaryData?.user">
              <p class="fw-bold">CREATED BY</p>
              <p class="text-dark">{{ reconSummaryData.user }}</p>
            </div>
          </div>

          <hr />

          <div class="d-flex justify-content-evenly main-tiles">
            <div
              *ngIf="reconSummaryData?.summary?.eligible?.toString()"
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold">TOTAL VALID TRANSACTIONS</h6>
              <p>
                {{
                  reconSummaryData.summary.eligible +
                    reconSummaryData.summary.invoiced
                }}
                /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>

            <div
              *ngIf="
                reconSummaryData?.summary?.completes?.toString() && !isLiveRecon
              "
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">Already Complete</h6>
              <p>
                {{ reconSummaryData.summary.completes }} /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>

            <div
              *ngIf="
                reconSummaryData?.summary?.progressedCompletes?.toString() &&
                !isLiveRecon
              "
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">Changed to Complete</h6>
              <p>
                {{ reconSummaryData.summary.progressedCompletes }} /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>

            <div
              *ngIf="reconSummaryData?.summary?.rejected?.toString()"
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">
                {{ isLiveRecon ? 'Changed to buyer reject' : 'Buyer Reject' }}
              </h6>
              <p>
                {{ reconSummaryData.summary.rejected }} /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>
            <div
              *ngIf="
                reconSummaryData?.summary?.liveReconciled?.toString() ||
                (reconSummaryData?.summary?.progressedReconciled?.toString() &&
                  !isLiveRecon)
              "
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">RECONCILED</h6>
              <p>
                {{
                  isLiveRecon
                    ? reconSummaryData.summary.liveReconciled
                    : reconSummaryData.summary.progressedReconciled
                }}
                /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>

            <div
              *ngIf="
                reconSummaryData?.summary?.invalid?.toString() &&
                reconSummaryData?.summary?.alreadyReconciled?.toString() &&
                !isLiveRecon
              "
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">
                Ineligible and already reconciled
              </h6>
              <p>
                {{
                  reconSummaryData.summary.invalid +
                    reconSummaryData.summary.invoiced +
                    reconSummaryData.summary.alreadyReconciled
                }}
                /
                {{ reconSummaryData.summary.transactions }}
              </p>
            </div>

            <div
              *ngIf="
                reconSummaryData?.summary?.totalValidTransactions?.toString()
              "
              class="transaction-block p-3 border border rounded-2 m-2 text-center"
            >
              <h6 class="fw-bold text-uppercase">Survey Live Vs Closed</h6>
              <p>
                {{ reconSummaryData.summary.totalValidTransactions.live }} /
                {{ reconSummaryData.summary.totalValidTransactions.close }}
              </p>
            </div>
          </div>
        </div>
        <div class="p-4 m-4 confirm_text_block">
          <p>
            The latest {{ isLiveRecon ? 'Live' : '' }} reconciliation processed
            successfully.
          </p>
          <p>
            Download the transaction_id's file for more details: RECONCILIATION
            SUMMARY FILE
          </p>
          <p>
            The transaction_id's changed their status from the following
            survey/s:
          </p>
          <ul>
            <li>
              <p>{{ recoModalSurveyList }}</p>
            </li>
          </ul>
          <ng-container *ngIf="livePausedSurveyList.length">
            <p class="fw-bold text-decoration-underline">
              NOTE: The following survey/s are not closed, hence some
              transaction/s are not reconciled.
            </p>
            <ul>
              <li>
                <p>{{ livePausedSurveyList }}</p>
              </li>
            </ul>
          </ng-container>
          <div *ngIf="invoicedSurveyList.length">
            <p>
              The following survey are Invoiced and any Transactions from
              this/these project will be skipped:
            </p>
            <ul>
              <li>{{ invoicedSurveyList }}</li>
            </ul>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Reconciliation modal for upload -->
    <div *ngIf="reconSummaryData.status">
      <div class="confirm-fix-box">
        <div class="confirm d-flex justify-content-center">
          <div class="">
            <label>FILE NAME</label>
            <p class="mt-2">
              {{
                reconSummaryData.fileName.substring(
                  reconSummaryData.fileName.indexOf('_') + 1
                )
              }}
            </p>
          </div>
          <div class="">
            <label>CREATED BY</label>
            <p class="mt-2">{{ reconSummaryData.user }}</p>
          </div>
        </div>
        <div
          class="d-flex flex-wrap confirm_box_container-reject"
          *ngIf="isLiveRecon"
        >
          <div class="confirm-box">
            <label>TOTAL VALID TRANSACTIONS</label>
            <p>
              {{
                reconSummaryData.summary.eligible +
                  reconSummaryData.summary.invoiced
              }}
              /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>INELIGIBLE AND ALREADY RECONCILED</label>
            <p>
              {{ ineligibleAndReconciled }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>CHANGE TO BUYER REJECT </label>
            <p>
              {{ reconSummaryData.summary.rejected }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>To BE RECONCILED </label>
            <p>
              {{ reconSummaryData.summary.eligible }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
        </div>
        <div
          class="d-flex flex-wrap confirm_box_container row"
          *ngIf="!isLiveRecon"
        >
          <div class="confirm-box">
            <label>TOTAL VALID TRANSACTION</label>
            <p>
              {{
                reconSummaryData.summary.eligible +
                  reconSummaryData.summary.invoiced
              }}
              /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>INELIGIBLE AND ALREADY RECONCILED</label>
            <p>
              {{ ineligibleAndReconciled }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>ALREADY COMPLETE</label>
            <p>
              {{ reconSummaryData.summary.completes }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>CHANGE TO BUYER REJECT </label>
            <p>
              {{ reconSummaryData.summary.rejected }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
          <div class="confirm-box">
            <label>To BE RECONCILED </label>
            <p>
              {{ reconSummaryData.summary.eligible }} /
              {{ reconSummaryData.summary.transactions }}
            </p>
          </div>
        </div>
      </div>
      <div class="row confirm-text" *ngIf="isLiveRecon">
        <ng-container *ngTemplateOutlet="reconCapSummary"></ng-container>
        <div class="col-md-6">
          <div class="confirm_text_block py-4 px-5">
            <p>
              You are uploading a
              <a class="rejectTxtColor"><b>REJECT</b></a> file that will change
              {{ reconSummaryData.summary.transactions }} transactions.
            </p>
            <p>
              The following projects will experience reconciliations from this
              upload:
            </p>
            <ul>
              <li>
                {{ recoModalSurveyList }}
              </li>
            </ul>
            <p>
              Each respondent transaction is eligible for a single
              reconciliation
            </p>
            <p *ngIf="!allSurveysRejectPercentageFine" style="color: #d12c34">
              Some of the surveys are not able to reconcile!
            </p>
            <div *ngIf="invoicedSurveyList.length">
              <p>
                The following survey are Invoiced and any Transactions from
                this/these project will be skipped:
              </p>
              <ul>
                <li>{{ invoicedSurveyList }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row confirm-text" *ngIf="!isLiveRecon">
        <ng-container *ngTemplateOutlet="reconCapSummary"></ng-container>
        <div class="col-md-6">
          <div class="confirm_text_block py-4 px-5">
            <p>
              You are uploading a
              <a class="acceptTxtColor"><b>ACCEPT</b></a> file that will keep
              {{ reconSummaryData.summary.transactions }} transactions.
            </p>
            <p>
              The following projects will experience reconciliations from this
              upload:
            </p>
            <ul>
              <li>
                {{ recoModalSurveyList }}
              </li>
            </ul>
            <div *ngIf="livePausedSurveyList.length">
              <p class="note-accept">
                NOTE: The following survey/s are not closed yet, if you want to
                reconcile all transactions, click CANCEL, close the survey/s and
                upload the reconciliation file again
              </p>
              <ul>
                <li>{{ livePausedSurveyList }}</li>
              </ul>
            </div>
            <p>
              Each respondent transaction is eligible for a single
              reconciliation
            </p>
            <p *ngIf="!allSurveysRejectPercentageFine" style="color: #d12c34">
              Some of the surveys are not able to reconcile!
            </p>
            <div *ngIf="invoicedSurveyList.length">
              <p>
                The following survey are Invoiced and any Transactions from
                this/these project will be skipped:
              </p>
              <ul>
                <li>{{ invoicedSurveyList }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer class="justify-content-between">
    <div class="text-center d-flex confirm_modal_btn">
      <a
        *ngIf="!reconSummaryData.status || !allSurveysRejectPercentageFine"
        class="status-change-no save_status closeButton"
        data-dismiss="modal"
        (click)="close()"
        >Close</a
      >
      <a
        *ngIf="reconSummaryData.status && allSurveysRejectPercentageFine"
        class="status-change-no text-decoration-none cancel_status"
        data-dismiss="modal"
        (click)="declineAdjustment(reconSummaryData.adjustmentId)"
        >Cancel</a
      >
      <a
        *ngIf="reconSummaryData.status && allSurveysRejectPercentageFine"
        [ngClass]="{ bg_gray: !allSurveysRejectPercentageFine }"
        class="status-change-yes save_status closeButton"
        data-dismiss="modal"
        (click)="confirmAdjustment(reconSummaryData.adjustmentId)"
        >Yes, let’s update</a
      >
    </div>
  </ps-ui-modal-footer>
</ps-ui-modal>
<!-- manual fix modal -->
<ps-ui-modal
  class="reconcileSummaryModal"
  *ngIf="mfSummaryData"
  [showButtonClose]="false"
>
  <ps-ui-modal-title class="center-align">MANUAL FIX</ps-ui-modal-title>
  <ps-ui-modal-body>
    <!-- Manual Fix modal for summary -->
    <div *ngIf="!mfSummaryData.status">
      <p>Transaction processed successfully:</p>
      <p>
        - {{ mfSummaryData.summary.transactions }} total transaction_id's
        changed status as per file uploaded.
      </p>
      <p>
        - {{ mfSummaryData.summary.test }} transactions are not valid to
        manually fix
      </p>
      <p>
        - {{ mfSummaryData.summary.buyerCPIValue }} transactions changed value
        of BUYER CPI.
      </p>
      <p>
        - {{ mfSummaryData.summary.supplierCPIValue }} transactions changed
        value of SUPPLIER CPI
      </p>
      <br />
      <p *ngIf="mfModalSurveyList">
        The transaction_id's changed their status from the following survey/s:
      </p>
      <p class="surveyList-id" *ngIf="mfModalSurveyList">
        {{ mfModalSurveyList }}
      </p>
    </div>
    <!-- Manual Fix modal for upload -->
    <div *ngIf="mfSummaryData.status">
      <p>Transaction processing summary:</p>
      <br />
      <p>
        - {{ mfSummaryData.summary.transactions }} total valid transaction_id's
        uploaded.
      </p>
      <p>
        - {{ mfSummaryData.summary.test }} transactions are not valid to
        manually fix
      </p>
      <p>
        - {{ mfSummaryData.summary.transactionsStatus }} transaction_id's will
        change status.
      </p>
      <p>
        - {{ mfSummaryData.summary.buyerCPIValue }} transactions will have a
        change in BUYER CPI value.
      </p>
      <p>
        - {{ mfSummaryData.summary.supplierCPIValue }} transactions will have a
        change in SUPPLIER CPI value.
      </p>
      <br />
      <p *ngIf="mfModalSurveyList">
        Transaction_id's from this file will manually fix the transaction from
        following survey/s:
      </p>
      <p *ngIf="mfModalSurveyList" class="surveyList-id">
        {{ mfModalSurveyList }}
      </p>
    </div>
    <br />
    <div class="text-center">
      <a
        *ngIf="!mfSummaryData.status"
        class="status-change-no save_status closeButton"
        data-dismiss="modal"
        (click)="close()"
        >Close</a
      >
      <a
        *ngIf="mfSummaryData.status"
        class="status-change-yes save_status closeButton"
        data-dismiss="modal"
        (click)="confirmAdjustment(mfSummaryData.adjustmentId)"
        >Confirm</a
      >
      <br />
      <a
        *ngIf="mfSummaryData.status"
        class="status-change-no text-decoration-none cancel_status noTksClose"
        data-dismiss="modal"
        (click)="declineAdjustment(mfSummaryData.adjustmentId)"
        >NO, Thanks</a
      >
      <br />
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>

<ng-template #reconCapSummary>
  <div *ngIf="isMultiSurvey" class="col-md-6 transaction_processing_block">
    <div class="transaction_process_box">
      <div>
        <h6 class="fw-bolder">Transaction to Process</h6>
      </div>
      <div class="flex_distribution_justify">
        <b class="header_description_multi_survey_recon">Survey number</b
        ><b class="header_description_multi_survey_recon">Transaction Result</b>
      </div>
      <div
        class="survey_summary_margin"
        *ngFor="let surveySummary of reconSummaryData.summary.summaryPerSurvey"
      >
        <ps-ui-accordion [arrowToggleOnly]="true">
          <ps-ui-accordion-section [isExpanded]="false">
            <ng-template psUiAccordionTitle>
              <span>
                <b>{{ surveySummary.surveyId }}</b>
                <b class="fw-bold survey_summary_title">Resulting Completes</b
                ><b
                  [ngClass]="{
                    red_percentage: !surveySummary.validCap
                  }"
                >
                  {{ surveySummary.resultingCompletes }}</b
                >
              </span>
            </ng-template>
            <ng-template psUiAccordionContent>
              <p
                *ngIf="!surveySummary.validCap"
                class="survey_summary_warning_description"
                style="color: #d12c34"
              >
                The number of total rejects, for this survey exceeds our
                threshold of {{ reconciliationRejectionPercentageLimit }}% and
                can’t be processed. Please upload a new file or contact
                PureSpectrum for assistance
              </p>
              <b class="fw-bold">Total Completes:</b>
              {{ surveySummary.totalRawCompletes }}
              <div class="process_action">
                Current Completes =
                {{ surveySummary.currentCompletes }}
                <span *ngIf="!isLiveRecon"
                  >+ Current Accepted =
                  {{ surveySummary.acceptingCompletesInCurrentUpload }}</span
                >
                + Previous Rejected =
                {{ reconSummaryData.summary.previouslyRejectedCompletes }}
              </div>
              <hr />
              <b class="fw-bold">Total Rejected:</b>
              {{ surveySummary.totalRejects }}
              <div class="process_action">
                Current Rejected =
                {{ surveySummary.rejectingCompletesInCurrentUpload }}
                + Previous Rejected =
                {{ surveySummary.previouslyRejectedCompletes }}
              </div>
              <hr />
              <b class="fw-bold">Total Accepting:</b>
              {{ surveySummary.completes }}
            </ng-template>
          </ps-ui-accordion-section>
        </ps-ui-accordion>
      </div>
    </div>
  </div>
  <div *ngIf="!isMultiSurvey" class="col-md-6 transaction_processing_block">
    <div class="transaction_process_box">
      <h6 class="fw-bolder">Transaction Processing</h6>
      <div class="result_box">
        <div class="trans_top_title">
          <span class="fw-bolder">{{
            reconSummaryData.summary.summaryPerSurvey[0].resultingCompletes
          }}</span>
          Resulting Completes
        </div>
        <div class="trans_description">
          {{ reconSummaryData.summary.summaryPerSurvey[0].totalRejects }} Total
          Rejected /
          {{ reconSummaryData.summary.summaryPerSurvey[0].totalRawCompletes }}
          Total Completes =
          <span
            >{{
              reconSummaryData.summary.summaryPerSurvey[0].rejectPercentage
            }}
            %</span
          >
        </div>
        <div *ngIf="!allSurveysRejectPercentageFine" class="red_description">
          <p>
            The number of total rejects, for this survey, exceeds the threshold
            of {{ reconciliationRejectionPercentageLimit }}% and can't be
            processed.
          </p>
          <p>Please upload a new file.</p>
        </div>
      </div>
      <ul class="transaction_terms">
        <li>
          <div class="process_lable">
            Total Completes<span class="black_num">{{
              reconSummaryData.summary.summaryPerSurvey[0].totalRawCompletes
            }}</span>
          </div>
          <div class="process_action">
            Current Completes =
            {{ reconSummaryData.summary.summaryPerSurvey[0].currentCompletes }}
            <span *ngIf="!isLiveRecon"
              >+ Current Accepted =
              {{
                reconSummaryData.summary.summaryPerSurvey[0]
                  .acceptingCompletesInCurrentUpload
              }}</span
            >
            + Previous Rejected =
            {{
              reconSummaryData.summary.summaryPerSurvey[0]
                .previouslyRejectedCompletes
            }}
          </div>
        </li>
        <li>
          <div class="process_lable">
            Total Rejected<span class="rejectTxtColor">{{
              reconSummaryData.summary.summaryPerSurvey[0].totalRejects
            }}</span>
          </div>
          <div class="process_action">
            Current Rejected =
            {{
              reconSummaryData.summary.summaryPerSurvey[0]
                .rejectingCompletesInCurrentUpload
            }}
            + Previous Rejected =
            {{
              reconSummaryData.summary.summaryPerSurvey[0]
                .previouslyRejectedCompletes
            }}
          </div>
        </li>
        <li *ngIf="!isLiveRecon">
          <div class="process_lable">
            Total Accepted<span class="acceptTxtColor">{{
              reconSummaryData.summary.summaryPerSurvey[0].resultingCompletes
            }}</span>
          </div>
          <div class="process_action">
            Current Accepted =
            {{
              reconSummaryData.summary.summaryPerSurvey[0]
                .acceptingCompletesInCurrentUpload
            }}
            + Current Remaining =
            {{
              reconSummaryData.summary.summaryPerSurvey[0].currentCompletes -
                reconSummaryData.summary.summaryPerSurvey[0]
                  .rejectingCompletesInCurrentUpload
            }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
